module.exports = __webpack_public_path__ + "img/user.2cf6b94d.svg";